module.exports = __webpack_public_path__ + "static/media/goodMeal.0df2eb32.png";